const enableLogging = process.env.NEXT_PUBLIC_ENABLE_LOGGING ?? "false";
const logLevel = process.env.NEXT_PUBLIC_LOG_LEVEL ?? "ERROR";

export const LogUtils = {
  error: (...args: unknown[]) => {
    if (enableLogging === "true" && logLevel === "ERROR") {
      console.log(...args);
    }
  },
  debug: (...args: unknown[]) => {
    if (enableLogging === "true" && logLevel === "DEBUG") {
      console.log(...args);
    }
  },
  log: (...args: unknown[]) => {
    if (enableLogging === "true" && logLevel === "INFO") {
      console.log(...args);
    }
  },
};
